export default __webpack_public_path__ + "static/media/activity_coloring_page_small.5255376e.png";